/**
 * Remove STOQ Restock Rocket's floating Notify Me tab whenever it appears.
 *
 * CSS in stoq-float-tab.css hides the tab, but the app embed can re-show it
 * on scroll with inline display:!important (stylesheet display:none loses).
 * Removing the float nodes is the reliable fix.
 *
 * Do not remove product preorder ATC, shipping notes, or Horizon
 * sticky-add-to-cart (the real Sold Out: Preorder control). Shop-card
 * badges stay for other products (serum may still use STOQ).
 * Thickening Shampoo is in stock — remove leftover Preorder chips
 * for that handle only.
 */
(function removeStoqFloatTab() {
  const SHAMPOO_HANDLE = 'thickening-shampoo';
  const SHAMPOO_PATH = '/products/thickening-shampoo';

  const FLOAT_SELECTOR = [
    '.restock-rocket-button-container-float-right',
    '.restock-rocket-button-container-float-left',
    '.restock-rocket-button-float',
    '.restock-rocket-button-cover',
  ].join(',');

  const PROTECTED_SELECTOR = [
    '.restock-rocket-preorder-button',
    '.restock-rocket-preorder-badge',
    '.restock-rocket-preorder-description',
    'sticky-add-to-cart',
  ].join(',');

  /**
   * @param {Element} element
   * @returns {boolean}
   */
  const isProtected = (element) => {
    return element.matches(PROTECTED_SELECTOR) || Boolean(element.closest(PROTECTED_SELECTOR));
  };

  /**
   * @param {Element} element
   * @returns {boolean}
   */
  const isShampooPreorderBadge = (element) => {
    if (!element.matches('.restock-rocket-preorder-badge')) return false;

    if (element.closest(`[data-product-handle="${SHAMPOO_HANDLE}"]`)) return true;

    const link = element.closest('a[href]');

    if (link && link.getAttribute('href')?.includes(SHAMPOO_PATH)) return true;

    const card = element.closest('.aslf-prod-card, .product-grid__item, product-card, .aslf-step-item');

    return Boolean(card && card.querySelector(`a[href*="${SHAMPOO_PATH}"]`));
  };

  /**
   * @param {ParentNode | Node} [root]
   */
  const removeShampooPreorderBadges = (root = document) => {
    if (!(root instanceof Node)) return;

    if (root instanceof Element && isShampooPreorderBadge(root)) {
      root.remove();
      return;
    }

    if (!(root instanceof Element) && !(root instanceof Document) && !(root instanceof DocumentFragment)) {
      return;
    }

    const badges = root.querySelectorAll('.restock-rocket-preorder-badge');

    for (const badge of badges) {
      if (isShampooPreorderBadge(badge)) {
        badge.remove();
      }
    }
  };

  /**
   * @param {ParentNode | Node} [root]
   */
  const removeFloatNodes = (root = document) => {
    if (!(root instanceof Node)) return;

    if (root instanceof Element && root.matches(FLOAT_SELECTOR) && !isProtected(root)) {
      root.remove();
      return;
    }

    if (!(root instanceof Element) && !(root instanceof Document) && !(root instanceof DocumentFragment)) {
      return;
    }

    const nodes = root.querySelectorAll(FLOAT_SELECTOR);

    for (const node of nodes) {
      if (isProtected(node)) continue;

      node.remove();
    }
  };

  removeFloatNodes();
  removeShampooPreorderBadges();

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        removeFloatNodes(node);
        removeShampooPreorderBadges(node);
      }
    }
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
  });

  let scrollTarget = null;

  const onScroll = () => {
    removeFloatNodes();
    removeShampooPreorderBadges();
  };

  const bindScroll = () => {
    if (scrollTarget) {
      scrollTarget.removeEventListener('scroll', onScroll);
    }

    const desktop = window.matchMedia('(min-width: 990px)').matches;
    scrollTarget = desktop ? document.querySelector('.page-wrapper') || document : document;
    scrollTarget.addEventListener('scroll', onScroll, { passive: true });
  };

  bindScroll();
  window.matchMedia('(min-width: 990px)').addEventListener('change', bindScroll);
})();
